import { History } from 'kh-design-system/components'
import React, { useEffect, useState } from 'react'
import { getTaskHistory } from '../../revampCRUD/taskManagement.crud'
import { ENTITY } from '../../reusable/common'
import customToast from '../../components/common/basic/Toast'
import HistoryItemShimmer from './HistoryItemShimmer'

const HistorySection = ({ assignmentId }) => {
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTaskHistoryDetails = async (entity, assignmentId) => {
    if (!assignmentId) return;

    setLoading(true);
    try {
      const result = await getTaskHistory(entity, assignmentId);

      if (result?.data?.activity?.length) {
        setHistoryData(result.data.activity);
      } else {
        setHistoryData([]);
      }
    } catch (error) {
      customToast.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTaskHistoryDetails(ENTITY.ENTITY_HISTORY, assignmentId);
  }, [assignmentId]);

  return (
    <div className='task-history'>
      {loading ? (
        <HistoryItemShimmer />
      ) : historyData.length > 0 ? (
        <History history={historyData} />
      ) : (
        <p className='text-center '>
          No history available
        </p>
      )}
      <style jsx>
        {`
          .task-history .history-item .profile-picture {
                margin-right: 10px;
            }
        `}
      </style>
    </div>
  );
};

export default HistorySection;
